import { FormLabel } from 'carbon-components-react';
import ReactQuill from 'react-quill';
import cn from 'classnames';

import './styles/RichTextInputQuillOverrides.scss';
import s from './styles/RichTextInput.module.scss';

export const RichTextInput = ({ label, value, className, onChange }) => (
  <div className={cn(s.root, className)}>
    {label && <FormLabel>{label}</FormLabel>}
    <ReactQuill
      value={value}
      onChange={onChange}
      modules={{
        toolbar: [
          [{ header: '1' }, { header: '2' }, { font: [] }],
          [{ size: [] }],
          ['bold', 'italic', 'underline', 'strike', 'blockquote'],
          [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
          ['link'],
          ['clean'],
        ],
      }}
      formats={[
        'header',
        'font',
        'size',
        'bold',
        'italic',
        'underline',
        'strike',
        'blockquote',
        'list',
        'bullet',
        'indent',
        'link',
      ]}
    />
  </div>
);
